import React from 'react'
import { useRecentMessageContext } from './Context'
import { DataSuspense, EmptyContent, HorizontalStack } from '@ztechapps/webui.util'
import { List } from './List'
import { BusyButton } from '@ztechapps/webui.button'
import { useMarkChatRead } from '@ztechapps/chat.common'

export const Layout = () => {
  const { error, loading, refetch, isEmpty, list } = useRecentMessageContext()
  const [markChatRead, { loading: markReadLoading, error: markReadError }] = useMarkChatRead()

  return (
    <div>
      <HorizontalStack className={'justify-content-between'}>
        <div>
          <h2 className="my-0">Unread Messages</h2>
          <small>List of all unread messages. Click the message to mark as read.</small>
        </div>
        <div>
          <BusyButton
            bsSize="sm"
            disabled={isEmpty}
            isBusy={markReadLoading || loading}
            title={'Mark all as read'}
            icon={'envelope-open'}
            onClick={async () => {
              const chatIds = [...new Set((list ?? []).map((message) => message?.chat?._id).filter(Boolean))]
              await Promise.all(chatIds.map((chatId) => markChatRead({ chatId })))
              //do a refresh after the mark all as read
              refetch()
            }}
          />
        </div>
      </HorizontalStack>

      <hr />
      <DataSuspense
        error={error || markReadError}
        loading={loading}
        isEmpty={isEmpty}
        emptyComponent={
          <EmptyContent icon={'envelope'} message="No new messages." subMessage="There are no new messages for now." />
        }
      >
        <List />
      </DataSuspense>
    </div>
  )
}
